import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { InstallResolve } from './install.resolve';
import { MainSideComponent } from './containers/main-side/main-side.component';
import { InstallComponent } from './install.component';
import { AuthGuard } from '../app.auth_guard';
import { integrateRoutes } from './integrate/integrate_routes';
import { mapRoutes } from './map/map_routes';
import { widgetRoutes } from './widget/widget_routes';
import { manualSetupRoutes } from './integrate/main/manual_setup/manual_setup_routes';
import { mobileRoutes } from './mobile/mobile_routes';
import { SingleComponent } from './containers/single/single.component';
import { RoleGuard } from '../role-guard.guard';
import { InstallNavigationGuard } from './install.navigation_guard';

const installRoutes: Routes = [
  {
    path: 'install',
    component: InstallComponent,
    resolve: {
      installData: InstallResolve
    },
    canActivateChild: [AuthGuard, RoleGuard, InstallNavigationGuard],
    children: [
      {
        path: '',
        component: LayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'map',
            pathMatch: 'full'
          },
          {
            path: 'map',
            component: MainSideComponent,
            children: mapRoutes
          },
          {
            path: 'widget',
            component: MainSideComponent,
            children: widgetRoutes
          },
          {
            path: 'integrate',
            component: MainSideComponent,
            children: integrateRoutes
          },
          {
            path: 'integrate/step2',
            component: MainSideComponent,
            children: manualSetupRoutes
          },
          {
            path: 'mobile',
            component: SingleComponent,
            children: mobileRoutes
          }
        ]
      }
    ]

  }
];

@NgModule({
  imports: [
    RouterModule.forChild(installRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class InstallRoutingModule {}
